import confetti from 'canvas-confetti';

const BRAND_COLORS = ['#FF3D7F', '#3D7FFF', '#A8E060', '#FFD93D', '#FF7A59', '#9B6BFF'];

/**
 * A small celebratory burst sized for marketing CTAs and hero entrances.
 * Throttled internally so rapid-fire hovers don't overwhelm the page.
 */
let lastBurstAt = 0;
export function smallBurst(originX = 0.5, originY = 0.5) {
  const now = Date.now();
  if (now - lastBurstAt < 300) return;
  lastBurstAt = now;

  confetti({
    particleCount: 60,
    spread: 70,
    startVelocity: 35,
    ticks: 200,
    gravity: 0.9,
    scalar: 0.9,
    origin: { x: originX, y: originY },
    colors: BRAND_COLORS,
    disableForReducedMotion: true,
  });
}

/**
 * Bigger, two-sided burst for "you just signed up" moments.
 */
export function bigBurst() {
  confetti({
    particleCount: 120,
    spread: 100,
    startVelocity: 45,
    ticks: 260,
    origin: { x: 0.2, y: 0.6 },
    colors: BRAND_COLORS,
    disableForReducedMotion: true,
  });
  confetti({
    particleCount: 120,
    spread: 100,
    startVelocity: 45,
    ticks: 260,
    origin: { x: 0.8, y: 0.6 },
    colors: BRAND_COLORS,
    disableForReducedMotion: true,
  });
}
